interface PredictionFormState {
  homeGoals?: string;
  awayGoals?: string;
  isBanker?: boolean;
}

interface SavedPrediction {
  match: { id: string };
  isBanker: boolean;
}

/** Returns the match id that currently has banker selected in this match week, if any. */
export function getBankerMatchIdInWeek(
  matchIds: string[],
  savedPredictions: SavedPrediction[],
  predictionForms: Record<string, PredictionFormState>
): string | null {
  const savedByMatchId = new Map(savedPredictions.map(p => [p.match.id, p]));

  for (const matchId of matchIds) {
    const form = predictionForms[matchId];
    const saved = savedByMatchId.get(matchId);
    const isBanker = form !== undefined ? Boolean(form.isBanker) : Boolean(saved?.isBanker);
    if (isBanker) {
      return matchId;
    }
  }

  return null;
}
